export const languageStrings: any = {
  हिंदी: {
    welcomeToJioBusiness: 'JioPay बिज़नेस में आपका स्वागत है',
    oneStopSolution: 'आपके व्यवसाय को बढ़ाने के लिए वन-स्टॉप समाधान।',
    next: 'अगला',
    skip: 'छोडना',
    getStarted: 'शुरू हो जाओ',
    acceptPaymentsFromCustomers: 'ग्राहकों से तुरंत भुगतान स्वीकार करें।',
    trackYourDailyTransactions: 'अपने दैनिक लेनदेन को आसानी से ट्रैक करें।',
    quickAndEasySettlements: 'सीधे आपके बैंक खाते में त्वरित और आसान निपटान।',
    login: 'लॉग इन करें',
    mobileNumber: 'मोबाइल नंबर',
    continue: 'जारी रखना',
    iAgree: 'क्लिक करके, मैं JioPay Business से सहमत हूं।',
    termsAndConditions: 'नियम एवं शर्तें',
    password: 'पासवर्ड',
    forgotPassword: 'पासवर्ड सेट/रीसेट करें?', // verify
    enterMobileNumberAssociated: 'अपने JioPay खाते से संबद्ध मोबाइल फ़ोन नंबर दर्ज करें',
    verificationRequired: 'सत्यापन की आवश्यकता',
    change: 'परिवर्तन',
    sentAnOTP: 'हमने उपरोक्त मोबाइल नंबर पर एक ओटीपी भेजा है।\nसत्यापन पूरा करने के लिए इसे दर्ज करें।',
    receivedOtp: 'यह प्राप्त नहीं हुआ? ',
    retryIn: 'इसमें पुन: प्रयास करें',
    resendOtp: 'ओटीपी पुनः भेजें',
    resetPassword: 'पासवर्ड रीसेट',
    passwordNote: 'पासवर्ड कम से कम 8 वर्णों का होना चाहिए।',
    viewAllPayments: 'पासवर्ड कम से कम 8 वर्णों का होना चाहिए।', // may not proper data from here
    loginUsingOtp: 'ओटीपी लॉगिन करें',
  },
  English: {
    welcomeToJioBusiness: 'Welcome to JioPay Business',
    oneStopSolution: 'One-stop solution to grow your business.',
    next: 'Next',
    skip: 'Skip',
    getStarted: 'Get Started',
    acceptPaymentsFromCustomers: 'Accept payments from customers instantly.',
    trackYourDailyTransactions: 'Track your daily transactions easily.',
    quickAndEasySettlements: 'Quick and easy settlements directly in your bank account.',
    login: 'Login',
    mobileNumber: 'Mobile Number',
    continue: 'Continue',
    iAgree: 'By clicking, I agree to JioPay Business (Jio Payment Solutions Limited)',
    inviteOnly: 'This application is currently invite only',
    termsAndConditions: 'Terms of use',
    password: 'Password',
    forgotPassword: 'Set/Reset Password',
    enterMobileNumberAssociated: 'Enter the mobile phone number associated with your JioPay account',
    verificationRequired: 'Verification required',
    change: 'Change',
    sentAnOTP: 'We’ve sent an OTP to the mobile number above.\nEnter it to complete verification.',
    receivedOtp: 'Didn’t receive it? ',
    retryIn: 'Retry in',
    resendOtp: 'Resend OTP',
    resetPassword: 'Set/Reset Password',
    passwordNote: 'Password must be at least 8 characters.',
    secureAccount: 'Secure your account',
    screenLockHelperText:
      'Use your existing phone lock to add additional layer of security to your JioPay Business account.',
    enableScreenLock: 'Enable screen lock',
    doItLater: 'I’ll do it later',
    viewAllPayments: 'View All Payments',
    appearRecentPayments: 'Recent payments from customers will appear here.',
    rencentTransactions: 'Recent Transactions',
    received: 'Received',
    quickLinks: 'Quick Links',
    learnNewTips: 'Learn New Tips',
    home: 'Home',
    payments: 'Payments',
    myQr: 'My QR',
    more: 'More',
    switchAccount: 'Switch Account',
    myDevices: 'My Devices',
    noDevicesLinked: 'No devices linked',
    linkedDevicesNote: 'Your linked devices will show up here',
    settled: 'Settled',
    refunded: 'Refunded',
    exportTxnStatement: 'Export Transaction Statement',
    genetrateAndDownload: 'Generate and Download',
    apply: 'Apply',
    jioPayChatAssistant: 'JioPay Chat Assistant',
    INTRODUCING: 'INTRODUCING',
    chatWithUs: 'Chat with us',
    help: 'Help',
    grievance: 'Grievance-Redressal',
    privacy: 'Privacy Policy',
    onboardingPolicy: 'Onboarding & KYC Policy',
    loginUsingOtp: 'Login using OTP',
  },
}

export const getLanguageText = (selectedLang: any, key: any, value: any) => {
  const languageString: any = {
    English: {
      endWith: `ending with ${value}`,
    },
    हिंदी: {
      endWith: `${value} के साथ समाप्त होता है`,
    },
  }
  return languageString?.[selectedLang]?.[key] ?? languageString?.English?.[key] ?? ''
}

export const getString = (selectedLanguage: any, stringKey: any) => {
  return languageStrings?.[selectedLanguage]?.[stringKey] ?? languageStrings?.English?.[stringKey]
}
